import React from "react";
import {
    Box,
    Center,
    Heading
} from "@chakra-ui/react";
import moment from "moment";
import { getCurrentIntakeYear, getCurrentIntakeMonth, getCurrentIntakeQuery } from "../utils/Dates";
import GaugeReport from "./reports/GaugeReport";
import { useFetchQueryCount, useFetchQuery } from "../api/fetchData";
import BarReport from "./reports/BarReport";
import FunnelReport from "./reports/FunnelReport";
import LeadCount from "./reports/LeadCount";
import PotentialsUsersCoursewiseCount from "./reports/PotentialsUsersCoursewiseCount";

const ExecutiveContent = ({ matrix5Ref, matrix6Ref, matrix7Ref, matrix8Ref, matrix9Ref, reportsMatrix }) => {
    const containerStyle = {
        borderRadius: 5,
        bg: 'gray.100',
        color: 'blue.900',
        style: {
            padding: 5
        }
    };
    const headerStyle = {
        as: 'h1',
        size: 'md',
        textAlign: 'center'
    };

    const today = moment().format('YYYY-MM-DD');
    const startDates = {
        January: `${getCurrentIntakeYear() - 1}-09-01`,
        April: `${getCurrentIntakeYear()}-01-01`,
        September: `${getCurrentIntakeYear()}-04-01`
    };

    const endDates = {
        January: `${getCurrentIntakeYear() - 1}-12-31`,
        April: `${getCurrentIntakeYear()}-03-31`,
        September: `${getCurrentIntakeYear()}-08-31`
    };

    const { targets } = useFetchQuery('Targets', '*', getCurrentIntakeQuery(), 'targets');
    const { count } = useFetchQueryCount('Potentials', 'COUNT(*)', `reg_payment_confirmed_date >= '${startDates[getCurrentIntakeMonth()]}' AND reg_payment_confirmed_date <= '${today}' AND ${getCurrentIntakeQuery()}`);

    return (
        <Box fontSize={{ base: '16px', xs: '12px', sm: '14px', md: '16px' }} >
            <Box {...containerStyle}>
                <Center paddingY={5}>
                    <Heading ref={matrix5Ref} {...headerStyle}>Target Reach Gauge</Heading>
                </Center>
                <GaugeReport startDate={startDates[getCurrentIntakeMonth()]} endDate={endDates[getCurrentIntakeMonth()]} targets={targets} totalPotentialCount={count} />
            </Box>
            <Box {...containerStyle}>
                <Center paddingY={5}>
                    <Heading ref={matrix6Ref} {...headerStyle}>Completed Days of intake</Heading>
                </Center>
                <BarReport startDate={startDates[getCurrentIntakeMonth()]} targets={targets} totalPotentialCount={count} />
            </Box>
            <Box {...containerStyle}>
                <Center paddingY={5}>
                    <Heading ref={matrix7Ref} {...headerStyle}>Sales Funnel</Heading>
                </Center>
                <FunnelReport module='Potentials' query={{ intake: getCurrentIntakeMonth(), intakeyear: getCurrentIntakeYear() }} reportsMatrix={reportsMatrix} />
            </Box>
            <Box {...containerStyle}>
                <Center paddingY={5}>
                    <Heading ref={matrix8Ref} {...headerStyle}>Lead Stage Breakdown</Heading>
                </Center>
                <LeadCount />
            </Box>
            <Box {...containerStyle}>
                <Center paddingY={5}>
                    <Heading ref={matrix9Ref} {...headerStyle}>Student Counselor Performance</Heading>
                </Center>
                <PotentialsUsersCoursewiseCount module='Potentials' hide={true} query={{ from: startDates[getCurrentIntakeMonth()], to: today, intake: getCurrentIntakeMonth(), intakeyear: getCurrentIntakeYear() }} />
            </Box>
        </Box>
    );
};

export default ExecutiveContent;
